module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-sign-up",
    class: (_vm.isPrint ? 'is-print' : undefined)
  }, [(!_vm.isPrint) ? _c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "Signup"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isPrint) ? _c('div-container', {
    staticClass: "form-print-logo",
    attrs: {
      "full": 'true',
      "column-num": 'is-11',
      "padding-bottom": "0"
    }
  }, [_c('div-columns', {
    attrs: {
      "full": 'true',
      "background-color": "gray",
      "text-align": 'center'
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo-main.svg")
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('page-subtab', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "column-num": (_vm.isPrint ? 'is-11' : undefined),
      "is-print": _vm.isPrint,
      "title-infos": _vm.applications,
      "selected-index": _vm.applicationIndex
    },
    on: {
      "title-changed": _vm.onApplicationChanged
    }
  }), _vm._v(" "), _c('div-container', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "column-num": (_vm.isPrint ? 'is-11' : undefined),
      "padding-bottom": "4rem"
    }
  }, [_c('div-columns', {
    attrs: {
      "full": (_vm.isPrint ? 'true' : undefined),
      "padding-top": "0rem",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [(!_vm.applications[0].isfull) ? _c('div', {
    staticClass: "column is-12 sign-up-team-section-wrapper",
    style: ([_vm.signUpTeamSectionWrapper])
  }, [_c('sign-up-team-section', {
    attrs: {
      "is-print": _vm.isPrint
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.applications[1].isfull) ? _c('div', {
    staticClass: "column is-12 sign-up-judge-section-wrapper",
    style: ([_vm.signUpJudgeSectionWrapper])
  }, [_c('sign-up-judge-section', {
    attrs: {
      "is-print": _vm.isPrint
    }
  })], 1) : _vm._e()])])], 1)], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ebac96a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SignUp.vue
// module id = 916
// module chunks = 1